import * as d3 from 'd3';
import { themesMixin } from '@/utils/themes';
import { fixedDecimals } from '@/utils/vuex';
import drawTextMixin from './d3textMixin.js';
export default {
  name: 'CoreChartDoughnut',
  mixins: [drawTextMixin, themesMixin],
  props: {
    size: {
      type: Number,
      default: 0
    },
    thickness: {
      type: Number,
      default: 30
    },
    value: {
      type: Number,
      default: 0
    }
  },
  computed: {
    color() {
      return this.vuetifyColorHex();
    },
    textColor() {
      return this.$store.state.app.UiTheme ? '#ccc' : '#333';
    }
  },
  watch: {
    size() {
      this.draw();
    },
    value() {
      this.draw();
    },
    color() {
      this.draw();
    },
    textColor() {
      this.draw();
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.draw();
    });
  },
  methods: {
    draw() {
      const thickness = Math.min(this.thickness, 50);
      const svgSize = 180;
      const innerRadius = svgSize / 2;
      const outerRadius = svgSize / 2 - thickness;
      const colors = [this.color, '#808080'];

      // clear existing svg content
      d3.select(this.$el).selectAll('*').remove();

      // render "N/A" if value is not a number
      if (isNaN(parseFloat(this.value))) {
        return this.drawNotAvailable();
      }
      const svg = d3.select(this.$el).attr('width', this.size || '100%').attr('height', this.size || '100%').attr('viewBox', `0 0 ${svgSize + 2} ${svgSize + 2}`).append('g').attr('transform', `translate(${svgSize / 2 + 1},${svgSize / 2 + 1})`);
      const data = [this.value, Math.max(100 - this.value, 0)];
      const color = d3.scaleOrdinal().domain(data).range(colors);
      const pie = d3.pie().sort(null).value(d => d.value);
      const dataReady = pie(Object.entries(data).map(([key, value]) => ({
        key,
        value
      })));
      svg.selectAll().data(dataReady).enter().append('path').attr('d', d3.arc().innerRadius(innerRadius).outerRadius(outerRadius)).attr('fill', d => color(d.data.key)).attr('opacity', d => d.index === 0 ? 1 : 0.4);
      const margin = (svgSize - outerRadius * 2) / 2 + 8;
      this.drawText(`${fixedDecimals(this.value, 2)}%`, {
        fontColor: this.textColor,
        x: margin,
        y: 0,
        width: svgSize - margin * 2,
        height: svgSize
      });
    }
  }
};